var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-header-title"},[_vm._v(" "+_vm._s(_vm.$t('components.safes.withdrawalsSafe'))+" ")]),(_vm.$parent.item.stat == 1 && _vm.$checkRole('safes_withdrawals_add'))?_c('router-link',{staticClass:"btn btn-sm btn-primary",attrs:{"to":'/safesWithdrawals/create?safe_id=' + _vm.$route.params.id}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('components.safes.addition'))+" ")]):_vm._e()],1),_c('indexTable',{attrs:{"searchText":_vm.$t('safesWithdrawals.searchForWithdrawals'),"withoutCard":true,"emptyTableText":_vm.$t('safesWithdrawals.thereAreNoWithdrawalsOperations'),"filter":{ safe_id: _vm.$route.params.id },"emptyTableSubText":_vm.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain'),"cloumns":[
        {
          column: 'code',
          title: _vm.$t('safesWithdrawals.operation'),
          type: 'mainLink',
          sort: true
        },
        {
          column: 'safe_id',
          title: _vm.$t('safesWithdrawals.safe'),
          type: 'link',
          to: 'safe',
          sort: true,
          link: true
        },
        {
          column: 'date',
          title: _vm.$t('safesWithdrawals.withdrawalsDate'),
          type: 'text',
          sort: true
        },
        {
          column: 'description',
          title: _vm.$t('safesWithdrawals.thatsAbout'),
          type: 'text',
          sort: true
        },
        {
          column: 'cost',
          title: _vm.$t('safesWithdrawals.amount'),
          type: 'text',
          sort: true
        },
        {
          column: 'options',
          title: _vm.$t('safesWithdrawals.settings'),
          type: 'options',
          options: [
            { name: 'show' },
            {
              name: 'edit',
              role: _vm.$checkRole('safes_withdrawals_edit')
            },
            {
              name: 'delete',
              role: _vm.$checkRole('safes_withdrawals_delete')
            }
          ]
        }
      ],"deleteText":{
        attention: _vm.$t('allerts.Attention'),
        areYouReallySureToDeleteTheItem: _vm.$t('allerts.areYouReallySureToDeleteTheItem'),
        close: _vm.$t('allerts.close'),
        confirm: _vm.$t('allerts.confirm'),
        loading: _vm.$t('allerts.loading')
      }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }